export function addListOfQueryParams(queryString: URLSearchParams, queryName: string, queryParams: string[]) {
    for (const idx in queryParams) {
        queryString.append(queryName, queryParams[idx]);
    }
    return queryString;
}